<style scoped lang='less'>
.cx-layout{position:absolute; left:0; top:0; right:0; bottom:0; padding:0; margin:0;}
/* 整体缩放 */
.cx-wrap-scale{position:absolute; left:0; top:0; width:100%; height:100%;overflow-y: scroll;overflow-x: hidden;}
#cx-scale{--scalex:1; --scaley:1;}
.cx-scale{position:absolute; left:0; top:0; transform:scale(var(--scalex), var(--scaley));}
.el-button{position:fixed;bottom: 10px;right: 20px;float: right; z-index: 99; width: 70px;font-size: 13px;border-radius: 5px;background-color: #ECF6FF;}
</style>

<template>
  <div class="cx-wrap-scale" id="cx-wrap-scale">
    <div v-wechat-title="title"></div>
    <ScaleBox>
      <div class="cx-layout">
        <headNavApp id="main" />
        <router-view></router-view>
        <Footer></Footer>
      </div>
    </ScaleBox>
  </div>
</template>

<script>
/* 插件-主布局 */
/**
 * 罗志远 主页面布局
 */
import HeadNavApp from './HeadNavApp.vue'
import Footer from '../project/Footer.vue'
import ScaleBox from '../assembly/ScaleBox.vue'
export default
{
  components: {HeadNavApp, Footer, ScaleBox},
  data()
  {
    return {
      title: sessionStorage.getItem('title') || this.$route.meta.title
    }
  },
  methods:
  {
    top()
    {
      document.querySelector('#main') && document.querySelector('#main').scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/layout/HomeApp.vue